export default function CloseCircleIcon(props) {

    let iconColor = props.active ? '#b60072' : '#D8D8D8'
    return  <svg className={props.className} xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                <path d="M13.292 0a13.292 13.292 0 1 0 13.291 13.292A13.307 13.307 0 0 0 13.292 0zm5.125 16.71a1.208 1.208 0 1 1-1.708 1.709L13.292 15 9.875 18.42a1.209 1.209 0 0 1-1.71-1.709l3.418-3.418-3.417-3.419a1.208 1.208 0 1 1 1.709-1.708l3.417 3.418 3.417-3.418a1.208 1.208 0 1 1 1.708 1.708L15 13.292l3.417 3.418z" fill={iconColor}/>
            </svg>
}